export default {
  device: null,
  category: null,
  stickers: null,
  themes: null,
  manufacturer: null,
  devices: null,
};
